import React from 'react';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { getDates, getTimes, getActualTime, getToday } from '../utils/helpers';
import ClientOnly from './ClientOnly';


export default ({
  onFilter, filters, className, small, withoutDateTime,
}) => {
  const onSelectFilter = (value) => {
    onFilter({
      type: 'filter',
      filter: value,
    });
  };

  const onSelectDate = (e) => {
    onFilter({
      type: 'date',
      filter: e.target.value,
    });
  };

  const onSelectTime = (e) => {
    onFilter({
      type: 'time',
      filter: e.target.value,
    });
  };

  const today = () => {
    onFilter({
      type: 'time',
      filter: getActualTime(),
    });
    onFilter({
      type: 'date',
      filter: getDates()[0].value,
    });
    console.log(getActualTime());
  }

  return (
    <Filters className={className} small={small}>
      <Filter
        small={small}
        selected={filters.filter === 'all'}
        onClick={() => onSelectFilter('all')}
      >
        Todas
      </Filter>
      <Filter
        small={small}
        selected={filters.filter === 'open'}
        onClick={() => onSelectFilter('open')}
      >
        Abiertas
      </Filter>
      <Filter
        small={small}
        selected={filters.filter === '24hrs'}
        onClick={() => onSelectFilter('24hrs')}
      >
        24 hrs.
      </Filter>      
      <Filter
        small={small}
        selected={filters.filter === 'domicilio'}
        onClick={() => onSelectFilter('domicilio')}
      >
        Domicilio
      </Filter>      
      <Filter
        small={small}
        selected={filters.filter === 'consultorio'}
        onClick={() => onSelectFilter('consultorio')}
      >
        Consultorio
      </Filter>      
      <Filter
        small={small}
        selected={filters.filter === 'auto'}
        onClick={() => onSelectFilter('auto')}
      >
        Entrega al Automovil
      </Filter>
{/*      <Filter
        small={small}
        selected={filters.filter === 'shift'}
        onClick={() => onSelectFilter('shift')}
      >
        De turno
      </Filter>*/}

      {!withoutDateTime && (
        <>
          <ClientOnly>
            <Select
              onChange={onSelectDate}
              defaultValue={getToday()}
            >
              {
            getDates().map((date) => (
              <Option value={date.value} key={date.text}>
                {date.text}
              </Option>
            ))
          }
            </Select>
          </ClientOnly>
          <IconSelect>
            <FontAwesomeIcon icon={faChevronDown} />
          </IconSelect>


          <Select
            onChange={onSelectTime}
            value={filters.time}
          >
            {
              getTimes().map((time) => (
                <Option value={time.value} key={time.value}>
                  {time.text}
                </Option>
              ))
            }
          </Select>

          <IconSelect>
            <FontAwesomeIcon icon={faChevronDown} />
          </IconSelect>
          <Button onClick={today} > Hoy </Button>
        </>
      )}
    </Filters>
  );
};

const Filters = styled.div`
  ${tw`
    flex items-center text-sm justify-around
  `}
  ${(props) => props.small && tw`
    text-base
  `}
`;

const Filter = styled.div`
  transition: all .3s;

  ${tw`
    border-0 border-b-4 border-solid border-transparent mx-2 pt-6 pb-5
    text-center w-20 cursor-pointer
  `}
  &:hover {
    color: #000099;
    border-color: #000099;
  }
  ${(props) => props.selected && css`
    color: #000099;
    border-color: #000099;
  `}
  ${(props) => props.small && tw`
    w-16 pt-4 pb-4
  `}
`;

const Select = styled.select`
  box-sizing: border-box;
  color: #5c5c5c;
  background-color: #F0F0F0;

  ${tw`
    border-none pl-6 pr-10 py-1 outline-none
    rounded-full mx-4 appearance-none cursor-pointer
  `}
`;

const Button = styled.button`
  box-sizing: border-box;
  color: #5c5c5c;
  background-color: #F0F0F0;

  ${tw`
    border-none px-6 py-1 outline-none
    rounded-full mx-4 appearance-none cursor-pointer
  `}
`;

const Option = styled.option``;

const IconSelect = styled.div`
  color: #000099;
  ${tw`
    relative -ml-10 mt-1
  `}
`;
